import Vue from 'vue'
import { getAuth, onAuthStateChanged } from 'firebase/auth'

const crispState = Vue.observable({
  unreadCount: 0
})

const updateUnreadCount = () => {
  if (window.$crisp && typeof window.$crisp.get === 'function') {
    try {
      crispState.unreadCount = window.$crisp.get('chat:unread:count') || 0
    } catch (e) {
      // Ignore if the method is not ready yet
    }
  }
}

const CrispPlugin = {
  install (VueInstance, options = {}) {
    const router = options.router
    const websiteId = process.env.VUE_APP_CRISP_WEBSITE_ID || 'bfa6a680-7847-482c-8bcb-31895798de1e'

    if (!websiteId) {
      console.warn('Crisp Website ID is not set. Crisp chat will not be loaded.')
      return
    }

    // Initialize Crisp SDK
    window.$crisp = []
    window.CRISP_WEBSITE_ID = websiteId
    ;(function () {
      const d = document
      const s = d.createElement('script')
      s.src = 'https://client.crisp.chat/l.js'
      s.async = 1
      d.getElementsByTagName('head')[0].appendChild(s)
    })()

    // Add reference to Vue prototype
    VueInstance.prototype.$crisp = window.$crisp
    VueInstance.prototype.$crispState = crispState

    let isAuthenticated = false

    // Function to check visibility based on route and auth state
    const updateVisibility = () => {
      if (!router || !router.currentRoute) return

      const to = router.currentRoute
      const isDesignerOrPreview = to.name === 'designer' ||
                                  to.name === 'template_preview' ||
                                  to.name === 'project_preview' ||
                                  to.name === 'user_project_preview' ||
                                  to.path.includes('/preview')

      if (isDesignerOrPreview) {
        window.$crisp.push(['do', 'chat:hide'])
      } else {
        if (isAuthenticated) {
          // If logged in, hide floating button (use sidebar button instead)
          window.$crisp.push(['do', 'chat:hide'])
        } else {
          // If not logged in, show floating button
          window.$crisp.push(['do', 'chat:show'])
        }
      }
    }

    // Track Auth State
    const auth = getAuth()
    onAuthStateChanged(auth, (user) => {
      isAuthenticated = !!user
      if (user) {
        window.$crisp.push(['set', 'user:email', [user.email]])
        if (user.displayName) {
          window.$crisp.push(['set', 'user:nickname', [user.displayName]])
        }
      } else {
        // Reset session on logout
        window.$crisp.push(['do', 'session:reset'])
        crispState.unreadCount = 0
      }

      // Update visibility after state changes
      updateVisibility()
      updateUnreadCount()
    })

    // Setup Crisp event callbacks
    window.$crisp.push(['on', 'session:loaded', () => {
      updateUnreadCount()
    }])

    window.$crisp.push(['on', 'message:received', () => {
      updateUnreadCount()
    }])

    window.$crisp.push(['on', 'chat:opened', () => {
      crispState.unreadCount = 0
    }])

    window.$crisp.push(['on', 'chat:closed', () => {
      // If user is logged in, hide the widget upon closing
      if (isAuthenticated) {
        window.$crisp.push(['do', 'chat:hide'])
      }
      updateUnreadCount()
    }])

    // Periodic check to ensure counter is synced
    setInterval(updateUnreadCount, 5000)

    // Track Navigation
    if (router) {
      router.afterEach(() => {
        updateVisibility()
        updateUnreadCount()
      })
    }
  }
}

export default CrispPlugin
